<template lang="html">

    <article class="oferta-el row-between">
        <div class="left">
            <div class="top row-start">
                <h4 class="codigo">[{{data.idoferta}}]</h4>
                <h2 class="titulo">{{data.titulo}}</h2>
            </div>
            <div class="middle row-start">
                <h3 class="status" :data="data.estado">{{dominios.estados[data.estado]}}</h3>
                <h3 v-if="!!data.fecha" class="fecha">{{data.fecha}}</h3>
                <h3 v-if="!!data.provincia" class="localizacion">{{data.provincia}}</h3>
                <h3 v-if="!!data.idSectorOferta" class="sector">{{dominios.sectores[data.idSectorOferta]}}</h3>
                <h3 v-if="!!data.empresa" class="empresa">{{data.empresa}}</h3>
            </div>
            <router-link :to="$t('enlaces.oferta')+'/'+data.urlAccesoOferta" class="enlace-cover"></router-link>
        </div>

        <div class="center">

            <span class="status" :data="data.estado" :title="'Estado '+dominios.estados[data.estado]"></span>

        </div>

        <div class="right">
            <a @click="desinscrirbirse" class="btn skull" v-if="!!oferta.puede_desincribirse" :loading="loading">Desinscribirme</a>
        </div>

        

    </article>

</template>

<script lang="js">

    import { mapGetters, mapActions } from 'vuex';


    export default {
        name: 'oferta',
        props: ['data'],
        data() {
            return {
                loading : false,
                oferta: {
                    puede_desincribirse: false,
                    candidatura: false
                }
            }
        },
        mounted() {
            this.oferta.puede_desincribirse = this.data.puede_desincribirse;
            this.oferta.candidatura = this.data.candidatura;
        },
        computed: {
            ...mapGetters({
                dominios: 'getDominios'
            })
        },
        methods: {
            ...mapActions(['requestDesincripcion']),
            desinscrirbirse() {
                this.loading = true;
                this.requestDesincripcion(this.data.urlAccesoOferta).then(r => {
                    if (r) {
                        this.oferta.puede_desincribirse = false;
                        this.loading = false;
                        this.$emit('erase',this.data.idCandidatura);
                    }
                }).catch(e =>{
                    this.loading = false;
                });
            }
        }

    }
</script>

<style scoped lang="scss">
    .right {
        min-width: 150px;
    }
</style>


// WEBPACK FOOTER //
// src/components/parts/candidaturas.vue